// Mirrors processing-service `processing.search.count-cap` (default 10000). The backend counts from the
// current page offset and stops at cap + 1 rows, so totalResults = offset + min(remaining, cap + 1):
// exact when the end is within cap rows of the current page, otherwise offset + cap + 1 = "more than".
export const SEARCH_COUNT_CAP = 10000;

const isCapped = (total, pagination) => {
	const current = (pagination && pagination.current) || 1;
	const pageSize = (pagination && pagination.pageSize) || 10;
	return total === (current - 1) * pageSize + SEARCH_COUNT_CAP + 1;
};

// The backend now reports an EXACT total for a filter (LUM-1771), cached per filter, so antd renders
// a button for every page and each one is addressable. The capped wording below is the fallback for
// when processing runs with `processing.search.exact-count.enabled=false`: without this detection a
// capped total would be presented as if it were exact, which is the LUM-1766 defect.
export const formatTotal = (total, noun, pagination) =>
	isCapped(total, pagination)
		? `More than ${(total - 1).toLocaleString()} ${noun} — the last page moves on to the next ${SEARCH_COUNT_CAP.toLocaleString()}`
		: `Total ${total.toLocaleString()} ${noun}`;

// Kept as an alias so nothing outside the Event Viewer breaks on the rename.
export const formatCappedTotal = formatTotal;
